import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import '../node_modules/bulma/css/bulma.min.css'
import App from './App'
import Store from './redux/Store'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <Provider store={Store}>
    <App/>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
